import React, { useEffect, useRef, useState } from "react";
import { Container, Filler } from "./styles";

interface Props {
  success: boolean;
}

export const ProgressBar = ({ success }: Props) => {
  const [progress, setProgress] = useState(0);
  const [animateToFull, setAnimateToFull] = useState(false);
  const [visible, setVisible] = useState(true);
  const animationRef = useRef<number>();
  const startTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (success) {
      cancelAnimationFrame(animationRef.current!);
      setAnimateToFull(true);
      setProgress(100);

      const timeout = setTimeout(() => {
        setVisible(false);
      }, 1000); // aguarda transição para sumir

      return () => clearTimeout(timeout);
    }

    const durationTo90 = 15000;
    const targetProgress = 90;

    const animate = () => {
      if (!startTimeRef.current) {
        startTimeRef.current = Date.now();
      }

      const elapsed = Date.now() - startTimeRef.current;
      const newProgress = Math.min((elapsed / durationTo90) * targetProgress, targetProgress);

      setProgress(newProgress);

      if (newProgress < targetProgress) {
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    setVisible(true);
    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current!);
  }, [success]);

  return (
    <Container visible={visible}>
      <Filler width={progress} animateToFull={animateToFull} />
    </Container>
  );
};
